import { Link } from 'react-router-dom';
import Container from '@/components/base/Container';
import { services } from '@/mocks/services';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <Container className="py-14 md:py-20">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <Link to="/" className="text-[15px] font-semibold tracking-[0.32em]">MENDWELL</Link>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/60">
              Expert in-home repairs for the appliances that keep your home running.
            </p>
            <Link to="/book" className="mt-7 inline-flex h-11 items-center whitespace-nowrap rounded-full bg-primary-500 px-5 text-sm text-white hover:bg-primary-600 mw-btn">
              Book a Repair
            </Link>
          </div>
          <div className="lg:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.16em] text-white/45">Services</h4>
            <ul className="mt-5 space-y-3 text-sm">
              {services.map((s) => (
                <li key={s.slug}><Link to={`/services/${s.slug}`} className="mw-link text-white/75 hover:text-white">{s.name}</Link></li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h4 className="text-[11px] uppercase tracking-[0.16em] text-white/45">Company</h4>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/about" className="mw-link text-white/75 hover:text-white">About</Link></li>
              <li><Link to="/services" className="mw-link text-white/75 hover:text-white">All Services</Link></li>
              <li><Link to="/technicians" className="mw-link text-white/75 hover:text-white">Technicians</Link></li>
              <li><Link to="/pricing" className="mw-link text-white/75 hover:text-white">Pricing</Link></li>
              <li><Link to="/reviews" className="mw-link text-white/75 hover:text-white">Reviews</Link></li>
              <li><Link to="/book" className="mw-link text-white/75 hover:text-white">Book a Repair</Link></li>
            </ul>
          </div>
          <div className="lg:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.16em] text-white/45">Service Areas</h4>
            <p className="mt-5 text-sm leading-relaxed text-white/60">
              Local in-home service. Coverage details are being finalized.
            </p>
            <Link to="/service-areas" className="mt-3 inline-block text-sm text-white/75 hover:text-white mw-link">View coverage <span className="mw-arrow">&rarr;</span></Link>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-6 text-xs text-white/45 sm:flex-row sm:justify-between">
          <p>&copy; 2026 MENDWELL. All rights reserved.</p>
          <p>Privacy policy and terms of service in preparation.</p>
        </div>
      </Container>
    </footer>
  );
}